import { Injectable } from "@angular/core"
import { Apollo } from "apollo-angular"
import gql from "graphql-tag"
import { writerFragment, Writer } from "./writer-profile-summary.queries"
import { map } from 'rxjs/operators'
import { Subscription } from "rxjs"
import { errorToast, successToast } from "src/toaster"

@Injectable({providedIn: 'root'})
export class WriterProfileSummaryMutations {
  private mutateSub: Subscription
  constructor(private apollo: Apollo) {}

  createInvoice(): Promise<Writer> {
    return new Promise((resolve, reject) => {
      this.apollo.mutate({
        variables: {input: {}},
        mutation: gql`
          mutation ($input: CreateWriterInvoiceInput!) {
            CreateWriterInvoice(input: $input) {
              errors
              writer {
                ...WriterProfileSummaryWriterFragment
              }
            }
          }
          ${writerFragment}
        `,
      }).pipe(map((result: any) => result.data.CreateWriterInvoice)).subscribe(({errors, writer}) => {
        if (errors.length > 0) {
          errors.forEach(e => errorToast(e))
          reject()
        } else {
          successToast("You've added to your pending invoice! You should receive payment Monday evening.")
          resolve(writer)
        }
      })
    })
  }


  toggleWriterUnavailableState(switchToUnavailable: boolean): Promise<any> {
    return new Promise ((resolve, reject) => {
      if (this.mutateSub) this.mutateSub.unsubscribe()
      this.mutateSub = this.apollo.mutate({
        variables: {input: {
          switchToUnavailable: switchToUnavailable
        }},
        mutation: gql`
          mutation ($input: ToggleWriterUnavailableStateInput!) {
            ToggleWriterUnavailableState(input: $input) {
              errors
              writer {
                id
                state
              }
            }
          }
        `,
      }).subscribe(({ data }: {data: any}) => {
        if (data && data.ToggleWriterUnavailableState.errors && data.ToggleWriterUnavailableState.errors.length > 0) {
          data.ToggleWriterUnavailableState.errors.forEach(e => errorToast(e))
        } else {
          if (data) {
            resolve(data)
          }
        }
      }, (error) => {
        errorToast(error)
        reject()
      })
    })
  }
}
